import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import DashboardTopBarAdmin from "../../components/admin/DashboardTopBarAdmin";
import SuccesButton from "../../components/shared/SuccessButton";
import Modal from "../../components/shared/Modal";

import settingsBlueIcon from "../../assets/admin/icons/settings-blue.svg";
import editIconWhite from "../../assets/admin/icons/edit-white.svg";
import AccountSettingsFormAdmin from "../../components/admin/settings/AccountSettingsFormAdmin";
import { fetchAccountSettings } from "../../util/admin/httpAdmin";
import KeyValueTable from "../../components/shared/KeyValueTable";

function SettingsAdmin() {
    const modalRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const [formKey, setFormKey] = useState(0); // Unieke sleutel voor het opnieuw renderen van het formulier

    const openModal = () => {
        if (modalRef.current?.open) {
            modalRef.current.open();
        } else {
            console.error("Modal reference is not correctly initialized.");
        }
    };

    const closeModal = () => {
        if (modalRef.current?.close) {
            modalRef.current.close();
        }

        setTimeout(() => {
            setFormKey((prevKey) => prevKey + 1); 
        }, 500)
    };

    const beforeCloseEditForm = () => {
        const params = new URLSearchParams(location.search);
        params.delete("edit");
        const newQuery = params.toString();
        navigate(`${location.pathname}${newQuery ? `?${newQuery}` : ""}`, { replace: true });
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("edit") === "true") {
            openModal();
        }
    }, [location]);

    const { data: accountData, isLoading, isError, error } = useQuery({
        queryKey: ["accountSettings"],
        queryFn: fetchAccountSettings,
    });

    let content;
    if (isLoading) {
        content = <p>Laden...</p>;
    } else if (isError) {
        content = <p className="c-r">Er is een fout opgetreden: {error.message}</p>;
    } else {
        const accountInfo = {
            Naam: accountData?.name,
            Winkelnaam: accountData?.shopName,
            Winkelomschrijving: accountData?.shopDescription,
            Winkeladres: accountData?.shopAddress,
            Email: accountData?.email,
            "Minimaal aantal uren dat op voorhand besteld moet worden.": accountData.shopMinimumOrderTimeBeforePickup,
            "Contact Email": accountData.contactEmail,
            "Contact Gsm": accountData.contactGsm,
            "Website": accountData.websiteUrl,
        };

        content = (
            <div className="py-20 px-20">
                <KeyValueTable data={accountInfo} />
            </div>
        );
    }

    return (
        <div>
            <DashboardTopBarAdmin
                title="Instellingen"
                icon={settingsBlueIcon}
                description="Hier kun je jouw accountinstellingen beheren"
            >
                <SuccesButton onClick={openModal}>
                    <div className="g-15-1fr f-s">
                        <img src={editIconWhite} alt="edit" />
                        Bewerken
                    </div>
                </SuccesButton>
            </DashboardTopBarAdmin>

            {content}

            <Modal ref={modalRef} beforeClose={beforeCloseEditForm}>
                <AccountSettingsFormAdmin key={formKey} onClose={closeModal} />
            </Modal>
        </div>
    );
}

export default SettingsAdmin;
